import i18n, { DEFAULT_FALLBACK_LANGUAGE } from '../i18n'

const SUPPORTED_LANGS = ['en', 'ru']

export const getCurrentLanguage = () => {
	const lang = i18n.language || DEFAULT_FALLBACK_LANGUAGE
	return lang.split('-')[0]
}

export const getLocalizedValue = value => {
	if (value === null) return value
	if (value === undefined) return value
	if (typeof value !== 'object') return value
	if (Array.isArray(value)) return value.join(', ')

	const lang = getCurrentLanguage()
	return (
		value[lang] ??
		value[DEFAULT_FALLBACK_LANGUAGE] ??
		value.ru ??
		Object.values(value).find(v => v !== null && v !== undefined && v !== '') ??
		''
	)
}

export const toMultilangValue = value => {
	if (value === null) return value
	if (value === undefined) return value
	if (typeof value === 'object' && !Array.isArray(value)) return value

	const text = String(value)
	return SUPPORTED_LANGS.reduce((acc, lang) => ({ ...acc, [lang]: text }), {})
}

// Defensive normalization: only `syndicator_summary` and `key_metrics` are
// genuinely multilang ({ en, ru }) in the DB. Other text fields (run_way,
// ebitda, investment_events, ...) are plain varchar, but the BOT can mistakenly
// write a multilang object into them when a translation is added. Any such
// object would throw "Objects are not valid as a React child" and blank out the
// whole project page (e.g. Educate Online). So instead of trusting a field
// list, we collapse ANY object-valued field to its localized string. Numbers,
// strings, arrays and null pass through untouched.
const localizeField = value =>
	value && typeof value === 'object' && !Array.isArray(value) ? getLocalizedValue(value) : value

export const normalizeReportForDisplay = report => {
	if (!report) return report
	return Object.fromEntries(Object.entries(report).map(([key, value]) => [key, localizeField(value)]))
}

export const normalizeReportPayload = values => ({
	...values,
	syndicator_summary: toMultilangValue(values.syndicator_summary),
	key_metrics: toMultilangValue(values.key_metrics)
})
